const postStrings = {
    status: {
        draft: "Черновик",
        queued: "В очереди",
        published: "Опубликован"
    }
}

export default postStrings;